module.exports = __webpack_public_path__ + "img/icon-web.652bf7a3.svg";